import { render, staticRenderFns } from "./GetStartCafe24.vue?vue&type=template&id=3165d3e3&scoped=true"
import script from "./GetStartCafe24.vue?vue&type=script&lang=js"
export * from "./GetStartCafe24.vue?vue&type=script&lang=js"
import style0 from "./GetStartCafe24.vue?vue&type=style&index=0&id=3165d3e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165d3e3",
  null
  
)

export default component.exports